import { createTheme } from '@mui/material/styles';

// Minimal MUI compatibility theme to avoid default blue primary/info
export const muiCompatTheme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
      contrastText: '#000000',
    },
    info: {
      main: '#fa5723',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#ffffff',
      secondary: '#7b8aa8',
    },
    background: {
      default: '#11161f',
      paper: '#141a22',
    },
  },
  components: {
    MuiSvgIcon: {
      defaultProps: {
        color: 'inherit',
      },
    },
  },
});


